<script setup lang="ts">
interface Props {
  duration?: `${number}ms`
}

const props = defineProps<Props>()
const duration = props.duration || '300ms'
</script>

<template>
  <div :class="$style.wrapper" aria-expanded="false" v-bind="$attrs">
    <div :class="$style['no-scrollbar']">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows ease-in-out;
  transition-duration: v-bind(duration);
}
.wrapper[aria-expanded='true'] {
  grid-template-rows: 1fr;
  & > div {
    overflow-y: visible;
    visibility: visible;
  }
}
.wrapper > div {
  overflow: hidden;
  visibility: collapse;
}

.no-scrollbar{
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
